import React, {useState} from 'react';
import {MoreHoriz} from "@mui/icons-material";
import AppbarActionButton from "../../../../../commons/elements/buttons/AppbarActionButton";
import {useStyles} from "./ScoredScenesPerformanceList.css";
import InformationDialog from "../../utils/dialog/InformationDialog";
import {NavLink} from "react-router-dom";
import ScoredSceneCardBasicLoadable from "../../../videosScored/card/scoredSceneCardBasic/ScoredSceneCardBasicLoadable";

export default function ScoredScenesPerformanceList({
                                                        headerPreview,
                                                        listPreview,
                                                        headerMore,
                                                        listMore,
                                                        metric,
                                                        unit,

                                                        // Overwrites the standard link, which leads to the scored scene definition by default
                                                        overwriteLinkPath = '',
                                                        overwriteLinkState = {}
                                                    }) {
    const classes = useStyles()

    // Information dialog title and content
    const [dialogTitle, setDialogTitle] = useState(null)
    const [dialogContent, setDialogContent] = useState(null)
    const [dialogOpen, setDialogOpen] = useState(false)

    // Triggering the pop-up which shows more worst rated scored scenes according to decision accuracy
    const handleViewMoreWorstRatedScenes = () => {

        setDialogTitle(headerMore)

        setDialogContent(<div className={classes.worstRatedContainer}>
            {listMore?.map((scoredSceneStat) => {
                const scoredSceneEntry = <div key={scoredSceneStat.key} className={classes.worstRatedRow}>
                    <div className={classes.worstRatedSummaryValue}>
                        {`${scoredSceneStat[metric]}${unit}`}
                    </div>
                    <div className={classes.worstRatedSummaryContent}>
                        <ScoredSceneCardBasicLoadable
                            scoredSceneKey={scoredSceneStat.key} clickable={!overwriteLinkPath}/>
                    </div>
                </div>

                if (overwriteLinkPath) {
                    return <div style={{width: "100%"}}>
                        <NavLink style={{textDecoration: 'none'}}
                                 to={{
                                     pathname: overwriteLinkPath,
                                     state: {
                                         ...overwriteLinkState,
                                         scoredSceneId: scoredSceneStat.key
                                     }
                                 }}>
                            {scoredSceneEntry}
                        </NavLink>
                    </div>
                }

                return scoredSceneEntry
            })}
        </div>)

        setDialogOpen(true)
    }

    return <div>

        {/* Dialog for showing complementary information, which does not fit on the dashboard.
            We use a plain MUI dialog in this case - otherwise a usage of a NavLink inside the
            dialog would not be possible, as it would be outside the react-router-dom. */}
        <InformationDialog title={dialogTitle} content={dialogContent} open={dialogOpen} setOpen={setDialogOpen}/>

        {/* Header */}
        <div className={classes.worstRatedHeader}>
            {headerPreview}
        </div>

        {/* List including worst rated scored scenes acc. to the given metric */}
        <div className={classes.worstRatedContainer}>
            {listPreview?.map((scoredSceneStat) => {
                const scoredSceneEntry = <div key={scoredSceneStat.key} className={classes.worstRatedRow}>
                    <div className={classes.worstRatedSummaryValue}>
                        {`${scoredSceneStat[metric]}${unit}`}
                    </div>
                    <div className={classes.worstRatedSummaryContent}>
                        <ScoredSceneCardBasicLoadable
                            scoredSceneKey={scoredSceneStat.key} clickable={!overwriteLinkPath}/>
                    </div>
                </div>

                if (overwriteLinkPath) {
                    return <div style={{width: "100%"}}>
                        <NavLink style={{textDecoration: 'none'}}
                                 to={{
                                     pathname: overwriteLinkPath,
                                     state: {
                                         ...overwriteLinkState,
                                         scoredSceneId: scoredSceneStat.key
                                     }
                                 }}>
                            {scoredSceneEntry}
                        </NavLink>
                    </div>
                }

                return scoredSceneEntry
            })}
        </div>

        {/* View more worst rated scored scenes acc. to the given metric */}
        <div className={classes.moreWorstRatedScoredScenesButtonContainer}>
            <AppbarActionButton className={classes.moreWorstRatedScoredScenesButton}
                                onClick={handleViewMoreWorstRatedScenes} label={"More"}
                                icon={<MoreHoriz/>}/>
        </div>

    </div>
}